import { type Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaAcceptedOffersEuropace } from '../tables';

type Arguments = {
    id: string;
    offerId: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetAcceptedOfferCommission = z
    .object({
        applicationId: schemaAcceptedOffersEuropace.shape.applicationId,
        commission: schemaAcceptedOffersEuropace.shape.commission,
    })
    .nullable();

export type SchemaLoanRequestResolver_GetAcceptedOfferCommission = z.infer<
    typeof schemaLoanRequestResolver_GetAcceptedOfferCommission
>;

export type LoanRequestResolver_GetAcceptedOfferCommission = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetAcceptedOfferCommission
>;
